/* ========================================================================= */
/*  cameraEntryTypes.ts  — merged action‑type constants + state definition   */
/* ========================================================================= */

/**
 * Every action string for the camera/photo entry slice.
 * Keep the keys synced with your reducer & saga.
 */
export const cameraEntryActionTypes = {
  /* async lifecycle */
  API_RESPONSE_SUCCESS: "CAMERA_API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR:   "CAMERA_API_RESPONSE_ERROR",

  /* local state setters */
  SET_IMAGE_BLOB:        "SET_IMAGE_BLOB",
  SET_IMAGE_PREVIEW_URL: "SET_IMAGE_PREVIEW_URL",
  SET_PROCESSING_STATUS: "CAMERA_SET_PROCESSING_STATUS",

  /* async trigger */
  SUBMIT_IMAGE_ENTRY:    "SUBMIT_IMAGE_ENTRY",

  /* housekeeping */
  CLEAR_ENTRY_RESULTS:   "CAMERA_CLEAR_ENTRY_RESULTS",
  SET_ERROR_MESSAGE:     "CAMERA_SET_ERROR_MESSAGE",
} as const;

/* Utility type if you ever need to refer to the keys */
export type CameraEntryActionTypeKeys = keyof typeof cameraEntryActionTypes;

/* Narrowed helper type for status */
export type ProcessingStatus = "idle" | "processing" | "done";

/**
 * Shape of the Redux state slice managed by cameraEntryReducer.
 */
export interface cameraEntryState {
  /* raw camera data */
  imageBlob: Blob | null;
  imagePreviewUrl: string | null;

  /* backend / UI status */
  processingStatus: ProcessingStatus;
  sqlResult: string;                        // SQL generated by backend
  entryResult: Record<string, unknown> | string; // DB row or message

  /* error / loading flags */
  errorMessage: string;
  loading: boolean;
  error: string;
}
